import { omit } from 'lodash';

import { FilterState } from '@/components/FilterManager/types';

import { FilterGroup, FilterOption } from '../types';

export const isItemSelected = (selectedOptions: FilterOption[], item?: FilterOption) => {
  if (!item) {
    return false;
  }
  return !!selectedOptions.find((option) => option.value === item.value);
};

export const omitKeysFromFilter = (filter: FilterState, ignoreFilterIds: string[]) => {
  return ignoreFilterIds ? omit(filter, ignoreFilterIds) : filter;
};

export const getMappedGroupToSelectedItems = (
  groups: FilterGroup[],
  selectedItems: FilterOption[],
) => {
  const selectedIds = selectedItems.map((item) => item.value);
  const mappedGroup: Record<string, FilterOption[]> = {};
  groups.forEach((group) => {
    mappedGroup[group.id] = group.options.filter((item) => selectedIds.includes(item.value));
  });
  return mappedGroup;
};
